import React from 'react';
import "./QuantityControl.css"

type QuantityControlProps = {
    quantity:number
    decrementButtonOnClick: () => void
    incrementButtonOnClick: () => void
    idPrefix?: string
    isIncrementDisabled?: boolean
}


const QuantityControl:React.FC<QuantityControlProps> = ({quantity,decrementButtonOnClick,incrementButtonOnClick, idPrefix, isIncrementDisabled = false}) => {
  const getId = (suffix: string) => idPrefix ? `${idPrefix}-${suffix}` : undefined;
  return (
    <div className="quantity-control-container">
        <button onClick={()=> decrementButtonOnClick()} id={getId('quantity-control-button-decrement')} className={`quantity-control-button`}>-</button>
        <span className='quantity-control-quantity'>{quantity}</span>
        <button onClick={()=> {incrementButtonOnClick() }} disabled={isIncrementDisabled} id={getId('quantity-control-button-increment')} className={`quantity-control-button${isIncrementDisabled ? ' quantity-control-button-disabled' : ''}`}>+</button>
    </div>

  )
}

export default QuantityControl